module.exports = __webpack_public_path__ + "static/media/bgCourses.46750767.png";